import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container as RBContainer, BackgroundImage } from 'rebass';
import { compose, branch, renderComponent } from 'recompose';
import styled, { css } from 'styled-components';
import log from 'loglevel';
import get from 'lodash/get';

import { login } from 'src/Redux/user-profile/actions';
import { isLogin, isLoading, loginError } from 'src/Redux/user-profile/selectors';
import { SPACE, COLOR } from 'src/Components/Theme';
import LoginForm from 'src/Components/LoginForm';
import ContentWrapper from 'src/Components/ContentWrapper';
import { Box } from 'src/Components/Base';

import { RobotLoading } from '../../Components/Loading';

const BannerBox = styled(Box)`
  ${({ imgurl }) => css`
    background: url(${imgurl}) center center no-repeat;
  `}
  width: 100%;
  min-height: 118px;
  background-color: ${COLOR.white};
  background-size: contain;
`;

const LContainer = styled(RBContainer)`
  min-width: 320px;
  max-width: 500px;
`;

const LBGImage = styled(BackgroundImage)`
  height: 100vh;
`;

const redirectImage = {
  '/confirmDek63': '/images/confirm/banner_confirm_login.png',
  '/confirmDek64': '/images/confirm/banner_confirm_login.png',
};

const getBanner = redirectPath => {
  return redirectImage[redirectPath];
};

class AuthRoute extends Component {
  handleEmailLogin = form => {
    this.props.login({ ...form, type: 'EMAIL' });
  };

  handleFaceBookLogin = data => {
    this.props.login({ type: 'FACEBOOK' });
  };

  handleRegisterClick = () => {
    this.props.history.push('/register', this.props.location.state);
  };

  handleForgotPasswordClick = () => {
    this.props.history.push('/forgot-password');
  };

  componentDidMount() {
    this.props.login({ type: 'ANONYMOUS' });
  }

  render() {
    const { isLoading, error, location } = this.props;
    const errorCode = error ? error.code : undefined;
    const redirectFrom = get(location, 'state.from.pathname');
    const bannerImg = getBanner(redirectFrom);
    // return (
    //   <LBGImage src="/background-main.png">
    //     <ContentWrapper>
    //       <LContainer>
    //         {bannerImg && <BannerBox imgurl={bannerImg} />}
    //         <LoginForm
    //           onEmailLoginClick={this.handleEmailLogin}
    //           onFacebookLoginClick={this.handleFaceBookLogin}
    //           onRegisterClick={this.handleRegisterClick}
    //           onForgotPasswordClick={this.handleForgotPasswordClick}
    //           loading={isLoading}
    //           errorCode={errorCode}
    //         />
    //       </LContainer>
    //     </ContentWrapper>
    //   </LBGImage>
    // );

    return (
      <ContentWrapper>
        <RobotLoading />
      </ContentWrapper>
    );
  }
}

export default compose(
  connect(
    state => ({ isLogin: isLogin(state), isLoading: isLoading(state), error: loginError(state) }),
    {
      login,
    },
  ),
  branch(
    props => props.isLogin,
    renderComponent(props => {
      const { from } = props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }),
  ),
)(AuthRoute);
